import getters from './getters';
import mutations from './mutations';
// eslint-disable-next-line import/no-cycle
import actions from './actions';

const state = {
  spCompanyRegistrationCompanyRecommendationInfo: {},
  spCompanyRegistrationCompanySocialNetworkLinkInfo: {},
  spCompanyRegistrationCompanyIpAddressInfo: {},
  spCompanyRegistrationEmailVerificationInfo: {},
  spCompanyRegistrationCompanyCertificationInfo: {},
  spCompanyRegistrationMainInfo: {},
  spCompanyServicesInfo: {},
  spCompanyCurrentStep: 1,
  spCompanyVisitedStepsCnt: 1,
  spCompanyFilledStepsCnt: 0,
  spCompanyLoading: {},
  companySuggestionsForSP: [],
  spCompanyLoadingErrors: {},
  spCompanyRecaptchaToken: null,
  spCompanyEmailVerificationSent: false,
  spCompanyClientAvatar: null,
  spCompanyServices: [],
  spCompanyCertificates: [],
  spCompanyRegions: [],
  spCompanyAmountOfEmployees: [],
};

export default {
  state,
  getters,
  mutations,
  actions,
};
